import { throwError as observableThrowError, Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import "rxjs/operators/map";

@Injectable()
export class AutenticacaoService {
  private apiUrl = environment.apiUrl;
  private loginUrl = environment.apiUrlAuth;

  constructor(private _http: HttpClient, private _router: Router) {}

  getToken() {
    if (!localStorage.getItem("token")) {
      return "";
    }
    return JSON.parse(localStorage.getItem("token"));
  }

  login(credenciais): Observable<{}> {
    return this._http.post(this.loginUrl, credenciais).pipe(
      map((res: any) => {
        localStorage.setItem("token", JSON.stringify(res["token"]));
        localStorage.setItem("usuario", JSON.stringify(res["usuario"]));
        return <any>res;
      })
    );
  }

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    this._router.navigate(["/login"]);
  }

  private handleError(error) {
    console.log(error);
    return observableThrowError(error.json() || "Server error");
  }
}
